<div class="filter-row">
  <ng-content></ng-content>
  <ng-content select=".filter-end"></ng-content>
</div>
<ng-content select=".filter-chips"></ng-content>
